const Config: AppConfig = {
	authUrl: import.meta.env["VITE_AUTH_URL"]!,
	branch: import.meta.env["VITE_BUILD_BRANCH"]!,
	buildVersion: import.meta.env["VITE_BUILD_VERSION"]!,
	clientId: import.meta.env["VITE_CLIENT_ID"]!,
	endpoint: import.meta.env["VITE_GRAPHQL_ENDPOINT"]!,
	environment: import.meta.env["VITE_BUILD_ENV"]!,
	idbVersion: 1,
	releaseVersion: import.meta.env["VITE_RELEASE_VERSION"]!,
	sentryDSN: "https://4fb4614bba8ab5de9c6a542d605dffb1@o1137736.ingest.us.sentry.io/4509367914856448",
	sfApiUrl: import.meta.env["VITE_SF_API_URL"]!,
	tenantId: import.meta.env["VITE_TENANT_ID"]!,
	tokenDuration: parseInt(import.meta.env["VITE_TOKEN_DURATION_SECONDS"]!) || 3600,
};

export default Config;
